import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UserInvitationVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveUserInvitations = createAsyncThunk<UserInvitationVM[], void, { extra: Partial<Dependencies> }>(
  "users/retrieveUserInvitations",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listUserInvitations();
  },
);
